import {
  GROUP_CARD_LAYOUT_CLASS,
  GROUP_CARD_PROPS,
  GROUP_COVER_CLASS,
  GROUP_GRID_CLASS,
  PRESET_CARD_ACTIONS_GAP,
} from 'modules/manager/ui/components/preset-card-metrics';
import React from 'react';
import UDCard from 'ud-ui/components/card';

interface GroupCardSkeletonProps {
  canWrite?: boolean;
  canDuplicate?: boolean;
}

export const TemplateGroupCardSkeleton: React.FC<GroupCardSkeletonProps> = ({ canWrite = false, canDuplicate = false }) => {
  const iconsCount = (canDuplicate ? 1 : 0) + (canWrite ? 2 : 0);

  return (
    <UDCard {...GROUP_CARD_PROPS} interactive={false} className={GROUP_CARD_LAYOUT_CLASS} data-testid="template-group-card-skeleton">
      <div className={GROUP_COVER_CLASS}>
        <div className="skeleton-block size-16" />
      </div>
      <div className="flex min-w-0 flex-col gap-2 px-4 pt-4 pb-3">
        <div className="skeleton-block h-4 w-3/5" />
        <div className="skeleton-block h-3 w-2/5" />
      </div>
      <div className="border-lineSubtle mt-auto flex items-center justify-between border-t px-4 py-3">
        <div className="skeleton-block h-9 w-[91px]" />
        <div className="flex items-center" style={{ gap: PRESET_CARD_ACTIONS_GAP }}>
          {Array.from({ length: iconsCount }, (_, index) => (
            <div key={index} className="skeleton-block size-5" />
          ))}
        </div>
      </div>
    </UDCard>
  );
};

interface GroupGridSkeletonProps extends GroupCardSkeletonProps {
  count?: number;
}

export const TemplateGroupGridSkeleton: React.FC<GroupGridSkeletonProps> = ({ count = 8, ...cardProps }) => (
  <div className={GROUP_GRID_CLASS} data-testid="template-group-grid-skeleton" aria-hidden>
    {Array.from({ length: count }, (_, index) => (
      <TemplateGroupCardSkeleton key={index} {...cardProps} />
    ))}
  </div>
);
